import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Users2Icon } from 'lucide-react'
import { useCalculator, KPI_NASTUPY } from '@/contexts/CalculatorContext'

export function NastupyVisualCard() {
  const { nastupy } = useCalculator()

  const getIconColor = (index: number) => {
    if (index < nastupy) {
      if (index < KPI_NASTUPY) return 'text-green-500' // First KPI_NASTUPY are green (KPI)
      if (index < 10) return 'text-blue-500' // Next 2 are blue
      return 'text-purple-500' // Rest are purple
    }
    return 'text-gray-300' // Inactive icons
  }

  return (
    <Card className="w-full">
      <CardHeader>
        <div className="flex items-center gap-2">
          <Users2Icon className="w-5 h-5" />
          <div>
            <CardTitle>Vizualizace nástupů</CardTitle>
            <p className="text-sm text-muted-foreground mt-1">
              {nastupy < KPI_NASTUPY
                ? `Pro aktivaci KPI potřebujete ještě ${KPI_NASTUPY - nastupy} nástupů`
                : 'KPI aktivní'}
            </p>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-5 gap-2">
          {Array.from({ length: 20 }).map((_, index) => (
            <div 
              key={index} 
              className={`transition-colors duration-300 ${getIconColor(index)}`}
              title={`Nástup ${index + 1}`}
            >
              <Users2Icon className="w-6 h-6" />
            </div>
          ))}
        </div>
        <div className="flex justify-between mt-4 text-xs text-muted-foreground">
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 bg-green-500 rounded-full"></div>
            <span>KPI minimum ({KPI_NASTUPY})</span>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
            <span>Bonus (7-10)</span>
          </div>
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
            <span>Extra (11+)</span>
          </div>
        </div>
      </CardContent>
    </Card>
  )
} 